import axios from 'axios';
import { store } from '@/store';
import auth from '@/utils/auth';

const axiosInstance = axios.create();

axiosInstance.defaults.withCredentials = false;
// 設定 axios 的預設等待時間(60秒)，如 api 回應超過時間會拋出錯誤
axiosInstance.defaults.timeout = 60000;
// 設定 axios 在 api 回傳 401 狀態(未登入、token過期…等身份無法識別)時的預設動作，目前是設為跳出提示視窗及自動登出
axiosInstance.interceptors.response.use(function (response) {
    return response;
},  (error) => {

    // TOKEN 過期(401狀態)統一處理
    if (error.response && error.response.status === 401) {

        store.commit('setDialog', {
            title: 'Token 過期',
            text: '請重新登入',
            active: true
        });

        auth.logout();

        return Promise.reject();

    } else {
        return Promise.reject(error);
    }
});

axiosInstance.interceptors.request.use(
    function(config) {
        // check if this request should use withCredentials = true
        if (config.url.includes(process.env.VUE_APP_MEMBER_API_URL + 'member')) {
            config.withCredentials = true;
        }
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

export default axiosInstance;